export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_UPDATE = 'AUTH_UPDATE';
export const ACTIVATEEMAIL_AUTH_UPDATE = 'ACTIVATEEMAIL_AUTH_UPDATE';
export const MAINPHOTO_UPDATE = 'MAINPHOTO_UPDATE';
export const AUTH_ROLEGET = 'AUTH_ROLEGET';